import {
  Box,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import DashboardCard from "../../../../components/Cards/DashboardCard.js";
import project1 from "../../../../assets/Dashboard/project1.svg";
import project2 from "../../../../assets/Dashboard/project2.svg";
import project3 from "../../../../assets/Dashboard/project3.svg";
import project4 from "../../../../assets/Dashboard/project4.svg";
import project5 from "../../../../assets/Dashboard/project5.svg";
import project6 from "../../../../assets/Dashboard/project6.svg";
import TasksTable from "./TasksTable.js";
import TaskDetails from "./TaskDetails.js";
import { useState, useEffect } from "react";
import { showUnderDevelopment } from "../../../../components/Alert.js";
import { useSelector } from "react-redux";
import { decryptToken } from "../../../../Utlis/Encryption.js";
import { BASE_URL } from "../../../../components/BaseUrl.js";
import EditTask from "./EditDrawer.js";
import CalendarTask from "./TaskCalender.js";
import { convertUTCToLocalDateTime } from "../../../../components/dateTimeUtils";



import endtask from "../../../../assets/TaskIcons/endtask.svg";
import ontimestart from "../../../../assets/TaskIcons/ontimestart.svg";
import ontimeendtask from "../../../../assets/TaskIcons/ontimeendtask.svg";
import highprority from "../../../../assets/TaskIcons/highprority.svg";
import mediumprority from "../../../../assets/TaskIcons/mediumprority.svg";
import lowprority from "../../../../assets/TaskIcons/lowprority.svg";
import latestart from "../../../../assets/TaskIcons/latestart.svg";
import lateend from "../../../../assets/TaskIcons/lateend.svg";
import notdone from "../../../../assets/TaskIcons/notdone.svg";
import canceltask from "../../../../assets/TaskIcons/canceltask.svg";
import unvalidatedtasks from "../../../../assets/TaskIcons/unvalidatedtasks.svg";
import back from "../../../../assets/back.svg";
import CustomText, { textStyles } from "../../../../components/CustomText";

import { useLocation, useNavigate } from 'react-router-dom';
// import TasksByDateList from "./TasksByDateList.js";
import MapTask from "./MapTask.js";

import taskicon1 from "../../../../assets/LastetIcons/taskicon1.svg";
import taskicon2 from "../../../../assets/LastetIcons/taskicon2.svg";
import taskicon3 from "../../../../assets/LastetIcons/taskicon3.svg";
import taskicon4 from "../../../../assets/LastetIcons/taskicon4.svg";
import taskicon5 from "../../../../assets/LastetIcons/taskicon5.svg";
import taskicon6 from "../../../../assets/LastetIcons/taskicon6.svg";
import taskicon7 from "../../../../assets/LastetIcons/taskicon7.svg";
import taskicon8 from "../../../../assets/LastetIcons/taskicon8.svg";
import taskicon9 from "../../../../assets/LastetIcons/taskicon9.svg";
import taskicon10 from "../../../../assets/LastetIcons/taskicon10.svg";
import taskicon11 from "../../../../assets/LastetIcons/taskicon11.svg";
import taskicon12 from "../../../../assets/LastetIcons/taskicon12.svg";
import taskicon13 from "../../../../assets/LastetIcons/taskicon13.svg";
import taskicon14 from "../../../../assets/LastetIcons/taskicon14.svg";

const AllTasks = () => {
  const isMobile = useMediaQuery("(max-width:768px)");
  const { t } = useTranslation();
  const [selectedTask, setSelectedTask] = useState(null);
  const [openEditTask, setOpenEditTask] = useState(false);

 const navigate=useNavigate();
    const location = useLocation();
      const fromDashboard = location.state?.fromDashboard;
  const [selectedTaskId, setSelectedTaskId] = useState(null); // calendar/map/table sync
const [calendarTaskId, setCalendarTaskId] = useState(null);
  const [mapTaskId, setMapTaskId] = useState(null);
const [selectedStatus, setSelectedStatus] = useState(null);
const STATUS_MAP = {
  assigned: "assigned",
  pending: "in_progress",
  start: "assigned",
  startOnTime: "assigned",
  startLate: "delayed",
  endToday: "completed",
  endOnTime: "completed",
  endLate: "delayed",
  notDone: "not_done",
  cancelled: "cancelled",
  unvalidated: "unvalidated"
};
  const [taskDetails, setTaskDetails] = useState(null);
  const [byDateTasks, setByDateTasks] = useState([]);
  const [byDateMeta, setByDateMeta] = useState({ dateLabel: "", workerLabel: "" });
  const [counters, setCounters] = useState({
    assigned: 0,
    in_progress: 0,
    completed: 0,
    delayed: 0,
    not_done: 0,
    cancelled: 0,
    total_tasks: 0,
  });

  const token = useSelector((state) => state.auth.token);
  const decryptedToken = token ? decryptToken(token) : null;
const [priorityFilter, setPriorityFilter] = useState(null);

  // ✅ Fetch counters
  const fetchCounters = async () => {
    try {
      const res = await fetch(`${BASE_URL}/task-management/admin/tasks/counters`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${decryptedToken}`,
        },
      });
      const data = await res.json();
      if (!data.error) {
        setCounters(data.data.counters);
      }
    } catch (err) {
      console.error("Error fetching counters:", err);
    }
  };

  useEffect(() => {
    fetchCounters();
  }, []);

   const fetchTaskDetails = async (id) => {
    try {
      const res = await fetch(`${BASE_URL}/task-management/admin/tasks/${id}`, {
        headers: { Authorization: `Bearer ${decryptedToken}` },
      });
      const data = await res.json();
      console.log("task details id ",data)
      if (!data.error) {
        // setTaskDetails(data.data.task); 
          setTaskDetails({
        ...data.data.task,
        assignments: data.data.assignments || [],
                comments: data.data.comments || []   // 👈 include comments here

      });
      }
    } catch (err) {
      console.error("❌ Error fetching task details:", err);
    }
  };
  
  // const handleSelectTask = (id) => {
  //   setSelectedTaskId(id);
  //   fetchTaskDetails(id);
  // };
const handleSelectTask = (id) => {
  setSelectedTaskId(id);   // open details page
  setMapTaskId(id);
  fetchTaskDetails(id);
};
  const handleBack = () => {
    setSelectedTaskId(null);
    setTaskDetails(null);
    // clear by-date pane state
    setByDateTasks([]);
    setByDateMeta({ dateLabel: "", workerLabel: "" });
  };

  const handleCalendarFilterByDate = ({ date, workerId, tasks }) => {
    const dateLabel = new Date(date).toISOString().slice(0,10);
    const safe = Array.isArray(tasks) ? tasks : [];
    setByDateTasks(safe);
    setByDateMeta({ dateLabel, workerLabel: "" });
    const firstId = safe?.[0]?.id;
    if (firstId) {
      setSelectedTaskId(firstId);
      fetchTaskDetails(firstId);
    }
  };
const handleMapFilterTask = (id) => {
  setMapTaskId(id);
    setCalendarTaskId(id);    // calendar filter

};
const clearCalendarFilter = () => {
  setCalendarTaskId(null);
};
const clearCalendarAllFilters = () => {
  setCalendarTaskId(null);   // clear task-id filter
  setSelectedStatus(null); 
  clearPriorityFilter() // clear status filter
};
const isActiveStatus = (status) => selectedStatus === status;
const [selectedPriority, setSelectedPriority] = useState(null);
const [taskViewTab, setTaskViewTab] = useState("today");
const [filters, setFilters] = useState({
  status: null,
  priority: null,
});
const clearPriorityFilter = () => {
  setFilters(prev => ({ ...prev, priority: null }));
    setSelectedPriority(null); // 👈 THIS resets blue border

}

const formatTaskTimeRange = (startAt, endAt) => {
  const formatTime = (value) => {
    const formatted = convertUTCToLocalDateTime(value, {
      locale: "en-GB",
      formatOptions: {
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      },
    });
    return formatted === "—" ? "--" : formatted;
  };

  return `${formatTime(startAt)} - ${formatTime(endAt)}`;
};
  return (
    <>
              {fromDashboard && (
  <Box
    sx={{
      border: '1px solid #E4E6EF',
      borderRadius: 2,
      px: 2,
      backgroundColor: 'white',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      minHeight: 55,
      mb: 2,
      ml:1, mr:1
    }}
  >
    <Box
      sx={{ display: 'flex', alignItems: 'center', gap: 1.5, cursor: 'pointer' }}
      onClick={() => navigate(-1)}
    >
      <img src={back} style={{ width: 30, height: 30 }} />
      <CustomText
        sx={{
          ...textStyles.h1,
          fontWeight: 500,
          fontSize: '14px',
          color: '#626F86',
          textAlign: 'center'
        }}
      >
        {t('companyAdmin')} 
      </CustomText>
    </Box>
  </Box>
)}
   
    <Box
      sx={{
        pl: isMobile ? 0.5 : 1.5,
        pr: isMobile ? 0.5 : 0,
        py: 2,
      }}
    >
      {selectedTaskId ? (
        <Box sx={{ display: { xs: 'block', md: 'grid' }, gridTemplateColumns: byDateTasks.length ? '300px 1fr' : '1fr', gap: 2 }}>
          {byDateTasks.length > 0 && (
            <Box sx={{ background: '#fff', borderRadius: 2, p: 1, maxHeight: '80vh', overflowY: 'auto', border: '1px solid #E5E7EB' }}>
              {byDateMeta?.dateLabel && (
                <Box sx={{ px: 1, py: 1, fontSize: 12, color: '#64748B' }}>Tasks on {byDateMeta.dateLabel}</Box>
              )}
              {byDateTasks.map((t) => (
                <Box key={t.id} sx={{ px: 1.2, py: 1, borderRadius: 1, cursor: 'pointer', backgroundColor: t.id === selectedTaskId ? '#F1F5F9' : 'transparent', '&:hover': { backgroundColor: '#F8FAFC' } }} onClick={() => { setSelectedTaskId(t.id); fetchTaskDetails(t.id); }}>
                  <Box sx={{ fontSize: 13, fontWeight: 600, color: '#0F172A', mb: 0.25 }}>{t.title}</Box>
                  <Box sx={{ fontSize: 12, color: '#64748B' }}>{formatTaskTimeRange(t.start_at, t.end_at)}</Box>
                </Box>
              ))}
            </Box>
          )}
          <Box>
            <TaskDetails 
              task={taskDetails} 
              onBack={handleBack} 
              onRefresh={fetchTaskDetails}
            />
          </Box>
        </Box>
      ) : (
        <>

          <Box
            sx={{
              display: "grid",
              gap: 1,
              gridTemplateColumns: {
                xs: "1fr",
                sm: "repeat(2, 1fr)",
                md: "repeat(3, 1fr)",
                lg: "repeat(5, 1fr)",
              },
            }}
          >
            <DashboardCard
              icon={taskicon1}
              title={t("task.allTasks")}
              description={counters.allTasks}
               onClick={() => {
                setSelectedStatus(null);
                setSelectedPriority(null);
                setFilters({ status: null, priority: null });
              }}
  isActive={selectedStatus === null && selectedPriority === null}
    cardSx={{
    cursor: "pointer",
    border:
     "2px solid #091E4224",
   
  }}
              // onClick={showUnderDevelopment}
            />
            <DashboardCard
              icon={taskicon2}
              title={t("task.completedTasks")}
              description={counters.completedTasks}
                onClick={() => setSelectedStatus("completed")}
    cardSx={{
    cursor: "pointer",
    border:
      selectedStatus === "completed"
        ? "2px solid #006EC2"
        : "2px solid #091E4224",
   
  }}
              // onClick={showUnderDevelopment}
            />
            <DashboardCard
              icon={taskicon3}
              title={t("task.notCompletedTasks")}
                onClick={() => setSelectedStatus("in_progress")}
    cardSx={{
    cursor: "pointer",
    border:
      selectedStatus === "in_progress"
        ? "2px solid #006EC2"
        : "2px solid #091E4224",
   
  }}
              description={counters.notCompletedTasks}
              // onClick={showUnderDevelopment}
            />
            <DashboardCard
              icon={taskicon4}
              title={t("task.startOnTime")}
                onClick={() => setSelectedStatus("in_progress")}

              description={counters.onTimeStartTaskToday}
                 cardSx={{
    cursor: "pointer",
    border:
      selectedStatus === "in_progress"
        ? "2px solid #006EC2"
        : "2px solid #091E4224",
   
  }}
              // onClick={showUnderDevelopment}
            />
            <DashboardCard
              icon={taskicon5}
              title={t("task.startLate")}
                onClick={() => setSelectedStatus("in_progress")}
    cardSx={{
    cursor: "pointer",
    border:
      selectedStatus === "in_progress"
        ? "2px solid #006EC2"
        : "2px solid #091E4224",
   
  }}
              description={counters.lateStartTaskToday}
              // onClick={showUnderDevelopment}
            />
            <DashboardCard
              icon={taskicon6}
              title={t("task.endToday")}
                onClick={() => setSelectedStatus("completed")}
              description={counters.endTaskToday}
                  cardSx={{
    cursor: "pointer",
    border:
      selectedStatus === "completed"
        ? "2px solid #006EC2"
        : "2px solid #091E4224",
   
  }}
              // onClick={showUnderDevelopment}
            />






              <DashboardCard
              icon={taskicon7}
              title={t("task.endOnTime")}
                onClick={() => setSelectedStatus("completed")}
              description={counters.onTimeEndTaskToday}
                  cardSx={{
    cursor: "pointer",
    border:
      selectedStatus === "completed"
        ? "2px solid #006EC2"
        : "2px solid #091E4224",
   
  }}
              // onClick={showUnderDevelopment}
            />
              <DashboardCard
              icon={taskicon8}
              title={t("task.endLate")}
              description={counters.lateEndTaskToday}
                onClick={() => setSelectedStatus("delayed")}
                    cardSx={{
    cursor: "pointer",
    border:
      selectedStatus === "delayed"
        ? "2px solid #006EC2"
        : "2px solid #091E4224",
   
  }}
              // onClick={showUnderDevelopment}
            />
              <DashboardCard
              icon={taskicon9}
              title={t("task.notDone")}
                onClick={() => setSelectedStatus("not_done")}

              description={counters.notDoneUntilToday}
                  cardSx={{
    cursor: "pointer",
    border:
      selectedStatus === "not_done"
        ? "2px solid #006EC2"
        : "2px solid #091E4224",
   
  }}
              // onClick={showUnderDevelopment}
            />
               <DashboardCard
              icon={taskicon10}
              title={t("task.cancelled")}
                onClick={() => setSelectedStatus("cancelled")}

              description={counters.cancelledUntilToday}
              // onClick={showUnderDevelopment}
                  cardSx={{
    cursor: "pointer",
    border:
      selectedStatus === "cancelled"
        ? "2px solid #006EC2"
        : "2px solid #091E4224",
   
  }}
            />

              <DashboardCard
              icon={taskicon11}
              title={t("task.priorityHigh")}
              description={counters.priorityHighToday}
   onClick={() => {
  setSelectedPriority("high");
  setSelectedStatus(null);

  setFilters({
    status: null,
    priority: "high",
  });
}}
                 cardSx={{
    cursor: "pointer",
    border: selectedPriority === "high"
    ? "2px solid #006EC2"
    : "2px solid #091E4224",
   
  }}
              // onClick={showUnderDevelopment}
            />
              <DashboardCard
              icon={taskicon12}
              title={t("task.priorityMedium")}
              description={counters.priorityMediumToday}
 onClick={() => {
  setSelectedPriority("medium");
  setSelectedStatus(null);

  setFilters({
    status: null,
    priority: "medium",
  });
}}
                 cardSx={{
    cursor: "pointer",
     border: selectedPriority === "medium"
    ? "2px solid #006EC2"
    : "2px solid #091E4224",
   
  }}
              // onClick={showUnderDevelopment}
            />
                 <DashboardCard
              icon={taskicon13}
              title={t("task.priorityLow")}
              description={counters.priorityLowToday}
                               cardSx={{
    cursor: "pointer",
   
  border: selectedPriority === "low"
    ? "2px solid #006EC2"
    : "2px solid #091E4224",
   
  }}
onClick={() => {
  setSelectedPriority("low");
  setSelectedStatus(null);

  setFilters({
    status: null,
    priority: "low",
  });
}}
              // onClick={showUnderDevelopment}
            />
  <DashboardCard
              icon={taskicon14}
              title={t("task.unvalidated")}
              description={counters.notValidatedEvents}
                onClick={() => setSelectedStatus("unvalidated")}
                    cardSx={{
    cursor: "pointer",
    border:
      selectedStatus === "unvalidated"
        ? "2px solid #006EC2"
        : "2px solid #091E4224",
   
  }}

              // onClick={showUnderDevelopment}
            />
          </Box>
<Box sx={{mt:2, mb:1}}>
  {/* <CalendarTask onSelectTask={handleSelectTask} onFilterByDate={handleCalendarFilterByDate} /> */}

  <CalendarTask
  onSelectTask={handleSelectTask}
  onFilterByDate={handleCalendarFilterByDate}
  selectedTaskId={calendarTaskId}  // ✅ ADD THIS
  statusFilter={selectedStatus}
  onClearFilter={clearCalendarAllFilters}
   priorityFilter={filters.priority}
  taskViewTab={taskViewTab}

    

/>
</Box>
          <Box sx={{mt:2, mb:1}}>
            <MapTask   onSelectTask={handleSelectTask}      // for marker click → details
  mapTaskId={mapTaskId}                // map-only state
  clearMapTask={() => setMapTaskId(null)}
    statusFilter={selectedStatus}
  clearStatusFilter={() => setSelectedStatus(null)}
   priorityFilter={filters.priority}
     clearPriorityFilter={clearPriorityFilter}
  taskViewTab={taskViewTab}

  />
          </Box>
          <Box sx={{ }}>
             <TasksTable onSelectTask={handleSelectTask} 
              onMapFilter={handleMapFilterTask}
              statusFilter={selectedStatus}
    onClearStatus={() => setSelectedStatus(null)}
  priorityFilter={filters.priority}
  taskViewTab={taskViewTab}
  setTaskViewTab={setTaskViewTab}
/>
          </Box>
        </>
      )}
    </Box>
     </>
  );
};

export default AllTasks;

